import {WebGLBrandedDivider, type BrandedDividerParams} from '@github-ui/brand-webgl'
import type {Brand} from '../../types'

export type BrandedDividerProps = {
  brand?: Brand
  className?: string
}

// Maps the Contentful `brand` enum (Copilot/Security) to WebGL params.
// New brands added in Contentful must be wired up here.
const BRAND_PARAMS: Record<Brand, BrandedDividerParams> = {
  Copilot: {character: 'copilot', layout: 0},
  Security: {character: 'security', layout: 0},
}

export const BrandedDivider = ({className, brand}: BrandedDividerProps = {}) => {
  if (!brand) return null
  return <WebGLBrandedDivider key={brand} params={BRAND_PARAMS[brand]} className={className} />
}
